<template>
  <v-container>
    <v-breadcrumbs :items="breadcrumbs" class="pl-0 py-1">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>
    <v-card class="mt-3 mb-4">
      <v-card-title class="px-3 py-2">
        <h5>詳細情報</h5>
        <v-spacer></v-spacer>
        <v-dialog
            v-model="editFolderDialog"
            @input="(v) => v || closeEditFolderDialog()"
            max-width="500px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark v-bind="attrs" v-on="on">
              <v-icon left>mdi-folder-edit</v-icon>編集
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">データ詳細</span>
            </v-card-title>
            <v-card-text class="pb-0">
              <v-container class="pb-0">
                <p>* は必須項目です。</p>
                <v-form
                    ref="editFolderForm"
                    v-model="editFolderFormValid"
                    lazy-validation
                >
                  <v-menu
                      v-model="dialogShootingDateMenu"
                      :close-on-content-click="false"
                      :nudge-bottom="5"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          hide-details="auto"
                          outlined
                          dense
                          clearable
                          v-model="inputEditFolder.property.shooting_date"
                          label="撮影日"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        locale="jp-JP"
                        v-model="inputEditFolder.property.shooting_date"
                        @input="dialogShootingDateMenu = false"
                    ></v-date-picker>
                  </v-menu>
                  <v-select
                      hide-details="auto"
                      v-model="inputEditFolder.property.drone_type"
                      label="撮影機体"
                      outlined
                      clearable
                      dense
                      :items="drone_type_items"
                  ></v-select>
                  <v-text-field
                      hide-details="auto"
                      v-model="inputEditFolder.property.shooting_height"
                      label="高度(M)"
                      outlined
                      dense
                      clearable
                  ></v-text-field>
                  <v-text-field
                      hide-details="auto"
                      v-model="inputEditFolder.property.gimbal_angle"
                      label="ジンバル角度"
                      :rules="[v => (!v || !isNaN(v)) || '数字で入力してください。']"
                      outlined
                      dense
                      clearable
                  ></v-text-field>
                  <v-text-field
                      hide-details="auto"
                      v-model="inputEditFolder.side_wrap"
                      label="サイドラップ"
                      :rules="[v => (!v || !isNaN(v)) || '数字で入力してください。']"
                      outlined
                      dense
                      clearable
                  ></v-text-field>
                  <v-text-field
                      hide-details="auto"
                      v-model="inputEditFolder.overlap"
                      label="オーバーラップ"
                      :rules="[v => (!v || !isNaN(v)) || '数字で入力してください。']"
                      outlined
                      dense
                      clearable
                  ></v-text-field>
                  <v-select
                      hide-details="auto"
                      v-model="inputEditFolder.property.gcp"
                      label="GCP"
                      :items="gcps"
                      outlined
                      clearable
                      dense
                  ></v-select>
                  <v-select
                      hide-details="auto"
                      v-model="inputEditFolder.property.rtk"
                      label="RTK"
                      :items="rtks"
                      outlined
                      clearable
                      dense
                  ></v-select>
                  <v-select
                      hide-details="auto"
                      v-model="inputEditFolder.property.weather"
                      label="天気"
                      :items="weathers"
                      outlined
                      clearable
                      dense
                  ></v-select>
                  <v-text-field
                      hide-details="auto"
                      v-model="inputEditFolder.property.solar_radiation"
                      label="日射量"
                      :rules="[v => (!v || !isNaN(v)) || '数字で入力してください。']"
                      outlined
                      dense
                      clearable
                  ></v-text-field>
                  <v-text-field
                      hide-details="auto"
                      v-model="inputEditFolder.note"
                      label="備考"
                      outlined
                      dense
                      clearable
                  ></v-text-field>
                </v-form>
              </v-container>
            </v-card-text>
            <v-card-actions class="pt-0">
              <v-spacer></v-spacer>
              <v-btn depressed @click="closeEditFolderDialog">キャンセル</v-btn>
              <v-btn depressed color="primary" @click="editFolder">編集</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="px-3 py-2">
        <v-simple-table class="tb-readonly" dense readonly>
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-left">作成者</th>
              <th class="text-left">撮影日</th>
              <th class="text-left">撮影機体</th>
              <th class="text-left">高度(M)</th>
              <th class="text-left">ジンバル角度</th>
              <th class="text-left">サイドラップ</th>
              <th class="text-left">オーバーラップ</th>
              <th class="text-left">GCP</th>
              <th class="text-left">RTK</th>
              <th class="text-left">天気</th>
              <th class="text-left">日射量</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>{{ folder.created_user.split('@')[0] }}</td>
              <td>{{ folder.property.shooting_date }}</td>
              <td>{{ folder.property.drone_type }}</td>
              <td>{{ folder.property.shooting_height }}</td>
              <td>{{ folder.property.gimbal_angle }}</td>
              <td>{{ folder.side_wrap }}</td>
              <td>{{ folder.overlap }}</td>
              <td>
                {{
                  folder.property.gcp
                      ? "有り"
                      : folder.property.gcp === false
                      ? "無し"
                      : ""
                }}
              </td>
              <td>
                {{
                  folder.property.rtk
                      ? "有り"
                      : folder.property.rtk === false
                      ? "無し"
                      : ""
                }}
              </td>
              <td>
                {{
                  folder.property.weather
                      ? folder.property.weather === "sunny"
                      ? "晴れ"
                      : "曇り"
                      : ""
                }}
              </td>
              <td>{{ folder.property.solar_radiation }}</td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
    <v-card class="mt-3 mb-4">
      <v-card-title class="px-3 py-2">
        <h5>素材画像</h5>
        <span class="ml-3 d-flex align-center justify-center body-1"><small>(*.JPG, *.PNG)</small></span>
        <v-spacer></v-spacer>
        <!-- <v-dialog
          v-if="sharedState.role === 'admin' || sharedState.email === folder.created_user"
          v-model="imagesUploadDialog"
          @input="(v) => v || closeImagesUploadDialog()"
          max-width="400px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark v-bind="attrs" v-on="on">
              <v-icon left>mdi-cloud-upload</v-icon>アップロード
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">素材画像アップロード</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <div class="div-images-upload">
                  <v-row>
                    <v-col cols="auto">
                      <v-btn color="primary" text @click="onUploadImages"
                        >画像追加</v-btn
                      >
                    </v-col>
                    <v-col>
                      <h4 style="padding-top: 7px">
                        画像数：{{ inputImagesUpload.images.length }}
                      </h4>
                    </v-col>
                  </v-row>
                </div>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn depressed @click="closeImagesUploadDialog()"
                >キャンセル</v-btn
              >
              <v-btn depressed color="primary" @click="uploadImages"
                >アップロード</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog> -->
        <input
            ref="imagesUploader"
            class="d-none"
            type="file"
            multiple
            accept="image/*"
            @change="addImages"
            @click="$refs.imagesUploader.value = null"
        />
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="px-3 py-2">
        <v-simple-table dense>
          <template v-slot:default>
            <tbody>
            <tr>
              <td>サーモ画像</td>
              <td>{{ imagesStructure.thermalFiles.length + " ファイル" }}</td>
              <td class="text-right">
                <v-btn
                    v-if="imagesStructure.thermalFiles.length > 0"
                    color="primary"
                    text
                    @click="downloadZip('thermal')"
                >ダウンロード</v-btn
                >
                <!-- 管理者またはフォルダ作成者しか削除できない -->
                <v-btn
                    v-if="
                      imagesStructure.thermalFiles.length > 0 &&
                      (sharedState.role === 'admin' ||
                        sharedState.email === folder.created_user)
                    "
                    color="error"
                    text
                    @click="confirmDeleteImages('thermal')"
                >削除</v-btn
                >
              </td>
            </tr>
            <tr>
              <td>可視画像</td>
              <td>{{ imagesStructure.colorFiles.length + " ファイル" }}</td>
              <td class="text-right">
                <v-btn
                    v-if="imagesStructure.colorFiles.length > 0"
                    color="primary"
                    text
                    @click="downloadZip('color')"
                >ダウンロード</v-btn
                >
                <!-- 管理者またはフォルダ作成者しか削除できない -->
                <v-btn
                    v-if="
                      imagesStructure.colorFiles.length > 0 &&
                      (sharedState.role === 'admin' ||
                        sharedState.email === folder.created_user)
                    "
                    color="error"
                    text
                    @click="confirmDeleteImages('color')"
                >削除</v-btn
                >
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
    <v-card class="mt-3 mb-4">
      <v-card-title class="px-3 py-2">
        <h5>DroneDeploy等で作成したファイル（オルソ・点群等）</h5>
        <v-spacer></v-spacer>
        <v-dialog
            v-model="fileUploadDialog"
            @input="(v) => v || closeFileUploadDialog()"
            max-width="500px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark v-bind="attrs" v-on="on">
              <v-icon left>mdi-cloud-upload</v-icon>アップロード
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">オルソ・点群アップロード</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <p>* は必須項目です。</p>
                <v-form
                    ref="fileUploadForm"
                    v-model="fileUploadFormValid"
                    lazy-validation
                >
                  <v-select
                      v-model="inputFileUpload.app"
                      label="アプリ種類 *"
                      :items="apps"
                      required
                      :rules="[(v) => !!v || 'アプリ種類を選択してください。']"
                      outlined
                      clearable
                      dense
                      hide-details="auto"
                  ></v-select>
                  <v-select
                      hide-details="auto"
                      v-model="inputFileUpload.fileType"
                      label="ファイル種類 *"
                      :items="fileTypes"
                      required
                      :rules="[(v) => !!v || 'ファイル種類を選択してください。']"
                      outlined
                      clearable
                      dense
                      @change="
                      inputFileUpload.colorType =
                        inputFileUpload.fileType === 'las' || inputFileUpload.fileType === 'obj'
                          ? 'color'
                          : inputFileUpload.colorType
                    "
                  ></v-select>
                  <v-select
                      hide-details="auto"
                      v-model="inputFileUpload.colorType"
                      label="色種類 *"
                      :items="colorTypes"
                      required
                      :rules="[(v) => !!v || '色種類を選択してください。']"
                      outlined
                      clearable
                      dense
                      :disabled="inputFileUpload.fileType === 'las' || inputFileUpload.fileType === 'obj'"
                  ></v-select>
                  <v-file-input
                      hide-details="auto"
                      v-model="inputFileUpload.file"
                      label="ファイル選択 *"
                      required
                      :rules="[(v) => !!v || 'ファイルを選択してください。']"
                      outlined
                      clearable
                      dense
                  ></v-file-input>
                </v-form>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn depressed @click="closeFileUploadDialog">キャンセル</v-btn>
              <v-btn depressed color="primary" @click="uploadFile"
              >アップロード</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="px-3 py-2">
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
            <tr>
              <th>アプリ</th>
              <th>ファイル種類</th>
              <th>色種類</th>
              <th>アップロード時間</th>
              <th>ファイル名</th>
              <th class="text-center">アクション</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, i) in files" :key="i" :class="item.app">
              <td>{{ item.app }}</td>
              <td>{{ item.file_type === "las" ? "点群" : item.file_type === "obj" ? "3Dモデル" : item.file_type === "airprobe_report" ? "AI MODEL Aレポート" : "オルソ" }}</td>
              <td>
                {{
                  item.file_type === "las" || item.file_type === "obj"
                      ? "可視"
                      : item.color_type === "color"
                      ? "可視"
                      : item.color_type === "thermal" ? "サーモ" : 'AI MODEL Aレポート'
                }}
              </td>
              <td>{{ item.created_at.substr(0, 19).replace('T', ' ') }}</td>
              <td>{{ item.name }}</td>
              <td class="text-right">
                <v-btn
                    v-if="
                      item.name.toLowerCase().includes('.jpeg') ||
                      item.name.toLowerCase().includes('.jpg') ||
                      item.name.toLowerCase().includes('.png')
                    "
                    color="primary"
                    text
                    @click="viewFile(item)"
                >ビュー
                </v-btn>
                <v-btn color="primary" text @click="download(item.path, item.name)"
                >ダウンロード</v-btn
                >
                <!-- 管理者またはフォルダ作成者しか削除できない -->
                <v-btn
                    v-if="
                      sharedState.role === 'admin' ||
                      sharedState.email === item.created_user
                    "
                    color="error"
                    text
                    @click="confirmDeleteFile(item)"
                >削除</v-btn
                >
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
    <v-card class="mt-3 mb-4">
      <v-card-title class="px-3 py-2">
        <h5>ファイルの作成状況</h5>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="px-3 py-2">
        <h5>アイコン説明：</h5>
<!--    <v-icon color="success">mdi-checkbox-marked-circle</v-icon>成功です。
        <v-spacer></v-spacer> -->
        <v-icon color="#ffcc00">mdi-alert</v-icon>システムを使用する上で直接影響はありません。開発者が対応します。
        <v-spacer></v-spacer>
        <v-icon color="warning">mdi-alert</v-icon>リカパリ可能なエラーです。開発者へご連絡ください。
        <v-spacer></v-spacer>
        <v-icon color="error">mdi-close-octagon</v-icon>致命的なエラーです。アップロードからやり直す必要があります。開発者へご連絡ください。
      </v-card-text>
      <v-divider></v-divider>
      <v-card-text class="px-3 py-2 overflow-y-auto"
        id="scroll-target"
        style="max-height: 400px"
      >
        <v-simple-table dense>
          <template v-slot:default v-scroll:#scroll-target="onScroll" style="height: 1000px"
>
            <thead>
            <tr>
              <th>進捗</th>
              <th>状況</th>
              <th>時間</th>
              <th>参考</th>
              <th>メッセージ</th>
              <th>開発者向けエラー詳細</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, i) in folder_detail_logs" :key="i">
              <td>{{ getProcessName(item.log_type) }}</td>
              <td>
                <v-icon v-if="item.log_level==='INFO'" color="success">mdi-checkbox-marked-circle</v-icon>
                <v-icon v-if="item.log_level==='WARNING'" color="#ffcc00">mdi-alert</v-icon>
                <v-icon v-if="item.log_level==='ERROR'" color="warning">mdi-alert</v-icon>
                <v-icon v-if="item.log_level==='FATAL'" color="error">mdi-close-octagon</v-icon>
              </td>
              <td>
                {{ item.created_at.substr(0, 19).replace('T', ' ').split(' ')[0] }}
                <v-spacer></v-spacer>
                {{ item.created_at.substr(0, 19).replace('T', ' ').split(' ')[1] }}
              </td>
              <td>
                {{ getStatusName(item.log_status) }}
              </td>
              <td>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      class="d-inline-block text-truncate"
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{ item.message }}
                    </span>
                  </template>

                  <span>{{ item.message }}</span>
                </v-tooltip>
              </td>
              <td>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      class="d-inline-block text-truncate"
                      style="max-width: 150px;"
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{ item.stackstrace }}
                    </span>
                  </template>

                  <p style="width: 300px;">{{ item.stackstrace }}</p>
                </v-tooltip>
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
    <v-snackbar v-model="snackbar" top left timeout="-1">
      <div>アップロードできない下記のファイルを</div>
      <div>再度アップロードしてください。</div>
      <h4 v-for="(item, i) in errorFileNames" :key="i">{{ item }}</h4>
      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false"
        >閉じる</v-btn
        >
      </template>
    </v-snackbar>
    <v-dialog v-model="uploadingDialog" width="initial" persistent>
      <div class="overlay-content">
        <h4 class="mb-3">
          処理中です。戻るや画面更新やブラウザ閉じる操作を行わないでください。
        </h4>
        <div>
          <v-progress-linear
            v-model="uploadRate"
            height="25"
          >
            <strong>{{ Math.ceil(uploadRate) }}%</strong>
          </v-progress-linear>
        </div>
        <div v-if="loading === 'completing'">
          <v-progress-circular
              size="22"
              indeterminate
              color="primary"
          ></v-progress-circular>
          <v-icon v-if="loading === 'done'" color="green"
          >mdi-check-circle</v-icon
          >
          <span>処理中</span>
        </div>
      </div>
    </v-dialog>

  </v-container>
</template>
<script>
import {saveAs} from "file-saver";
import {store} from "../store";
import S3Axios from "@/utils/s3Axios";

export default {
  name: "FolderDetail",
  data() {
    return {
      sharedState: store.state,
      breadcrumbs: [
        {
          text: "発電所一覧",
          disabled: false,
          exact: true,
          to: "/plant",
        },
        {
          text: "",
          disabled: false,
          exact: true,
        },
        {
          text: "",
        },
      ],
      editFolderDialog: false,
      imagesUploadDialog: false,
      fileUploadDialog: false,
      uploadingDialog: false,
      dialogShootingDateMenu: false,
      editFolderFormValid: true,
      imagesUploadFormValid: true,
      fileUploadFormValid: true,
      inputEditFolder: {
        plant_id: null,
        name: null,
        property: {
          shooting_date: null,
          drone_type: null,
          shooting_height: null,
          gimbal_angle: null,
          gcp: null,
          weather: null,
          solar_radiation: null,
          rtk: null,
        },
        side_wrap: null,
        overlap: null,
        note: null,
      },
      inputImagesUpload: {
        images: [],
      },
      inputFileUpload: {
        app: null,
        fileType: null,
        colorType: null,
        file: null,
      },
      apps: ["dronedeploy", "terra", "pix4d", "airprobe", "opendronemap", 'opendronemap_lightning'],
      fileTypes: [
        { text: "オルソ", value: "tif" },
        { text: "点群", value: "las" },
        { text: "3Dモデル", value: "obj" },
      ],
      colorTypes: [
        { text: "サーモ", value: "thermal" },
        { text: "可視", value: "color" },
      ],
      gcps: [
        { text: "有り", value: true },
        { text: "無し", value: false },
      ],
      rtks: [
        { text: "有り", value: true },
        { text: "無し", value: false },
      ],
      weathers: [
        { text: "晴れ", value: "sunny" },
        { text: "曇り", value: "cloudy" },
      ],
      loading: "done",
      plant: {},
      block: {},
      folder: {
        block_id: null,
        name: null,
        property: {
          weather: null,
          solar_radiation: null,
        },
      },
      imagesStructure: {
        colorFiles: [],
        thermalFiles: [],
      },
      files: [],
      errorFileNames: [],
      uploadedFilesNum: 0,
      uploadFilesNum: 0,
      uploadRate: 0,
      snackbar: false,
      drone_type_items: ['M200', 'M300', 'MAVIC', 'M2EA', 'P4R', 'X4S', 'I1'],
      folder_detail_logs: [],
      processTypes: [
        { text: "ファイルアップロード", value: "000_FILE_UPLOAD" },
        { text: "DroneDeployのマッププラン作成", value: "120_DD_MAP_PLAN" },
        { text: "DronDeployマッププランへの可視画像アップロード", value: "141_DD_MAP_UPLOAD_COLOR" },
        { text: "DronDeployマッププランへのサーモ画像アップロード", value: "142_DD_MAP_UPLOAD_THERMAL" },
        { text: "DroneDeployの可視マップ作成APIステータス", value: "161_DD_MAP_CREATE_COLOR" },
        { text: "DroneDeployのサーモマップ作成APIステータス", value: "162_DD_MAP_CREATE_THERMAL" },
        { text: "DroneDeployの可視オルソ画像エクスポートAPIステータス", value: "181_DD_EXPORT_COLOR" },
        { text: "DroneDeployのサーモオルソ画像エクスポートAPIステータス", value: "182_DD_EXPORT_THERMAL" },
        { text: "MODEL Aのアップロード", value: "320_AP_UPLOAD" },
        { text: "MODEL Aの解析ステータス", value: "340_AP_ANALYZE" },
        { text: "MODEL A解析結果のダウンロード", value: "360_AP_DL" },
        { text: "MODEL A解析結果のマップ反映", value: "380_AP_REFLECT" },
        { text: "DronDeploy可視オルソ変換", value: "211_DD_xxx_COLOR" },
        { text: "DronDeployサーモオルソ変換", value: "212_DD_xxx_THERMAL" },
        { text: "DroneDeploy可視タイル化", value: "221_DD_TILE_COLOR" },
        { text: "DroneDeployサーモタイル化", value: "222_DD_TILE_THERMAL" },
        { text: "MODEL A可視タイル化", value: "521_AP_TILE_COLOR" },
        { text: "MODEL Aサーモタイル化", value: "522_AP_TILE_THERMAL" },
        { text: "DroneDeploy可視オルソ画像サイズ縮小化", value: "241_DD_RES50_COLOR" },
        { text: "DroneDeployサーモオルソ画像サイズ縮小化", value: "242_DD_RES50_THERMAL" },
        { text: "MODEL A可視オルソ画像サイズ縮小化", value: "541_AP_RES50_COLOR" },
        { text: "MODEL Aサーモオルソ画像サイズ縮小化", value: "542_AP_RES50_THERMAL" },
        { text: "DroneDeploy可視サムネル作成", value: "261_DD_THUMBNAIL_COLOR" },
        { text: "DroneDeployサーモサムネル作成", value: "262_DD_THUMBNAIL_THERMAL" },
        { text: "MODEL A可視サムネル作成", value: "561_AP_THUMBNAIL_COLOR" },
        { text: "MODEL Aサーモサムネル作成", value: "562_AP_THUMBNAIL_THERMAL" },
        { text: "DroneDeploy可視補正座標抽出", value: "281_DD_CCALC_COLOR" },
        { text: "DroneDeployサーモ補正座標抽出", value: "282_DD_CCALC_THERMAL" },
        { text: "MODEL A可視補正座標抽出", value: "581_AP_CCALC_COLOR" },
        { text: "MODEL Aサーモ補正座標抽出", value: "582_AP_CCALC_THERMAL" },

        { text: "ODMLightningの可視マップ作成APIステータス", value: "151_ODM_LIGHTNING_MAP_CREATE_COLOR" },
        { text: "ODMLightningのサーモマップ作成APIステータス", value: "152_ODM_LIGHTNING_MAP_CREATE_THERMAL" },
        { text: "ODMLightningの可視マップ作成ステータス", value: "181_ODM_LIGHTNING_CREATE_COLOR" },
        { text: "ODMLightningのサーモマップ作成ステータス", value: "182_ODM_LIGHTNING_CREATE_THERMAL" },
        { text: "ODMLightning可視タイル化", value: "621_ODM_LIGHTNING_TILE_COLOR" },
        { text: "ODMLightningサーモタイル化", value: "622_ODM_LIGHTNING_TILE_THERMAL" },
        { text: "ODMLightning可視オルソEPSGコード交換", value: "631_ODM_LIGHTNING_EPSG_CONVERT_COLOR" },
        { text: "ODMLightningサーモオルソEPSGコード交換", value: "632_ODM_LIGHTNING_EPSG_CONVERT_THERMAL" },
        { text: "ODMLightning可視オルソ画像サイズ縮小化", value: "641_ODM_LIGHTNING_RES50_COLOR" },
        { text: "ODMLightningサーモオルソ画像サイズ縮小化", value: "642_ODM_LIGHTNING_RES50_THERMAL" },
        { text: "ODMLightning可視サムネル作成", value: "661_ODM_LIGHTNING_THUMBNAIL_COLOR" },
        { text: "ODMLightningサーモサムネル作成", value: "662_ODM_LIGHTNING_THUMBNAIL_THERMAL" },
        { text: "ODMLightning可視補正座標抽出", value: "681_ODM_LIGHTNING_CCALC_COLOR" },
        { text: "ODMLightningサーモ補正座標抽出", value: "682_ODM_LIGHTNING_CCALC_THERMAL" },

        { text: "ODMの可視マップ作成APIステータス", value: "171_ODM_MAP_CREATE_COLOR" },
        { text: "ODMのサーモマップ作成APIステータス", value: "172_ODM_MAP_CREATE_THERMAL" },
        { text: "ODMの可視マップ作成ステータス", value: "191_ODM_CREATE_COLOR" },
        { text: "ODMのサーモマップ作成ステータス", value: "192_ODM_CREATE_THERMAL" },
        { text: "ODM可視タイル化", value: "721_ODM_TILE_COLOR" },
        { text: "ODMサーモタイル化", value: "722_ODM_TILE_THERMAL" },
        { text: "ODM可視オルソEPSGコード交換", value: "731_ODM_EPSG_CONVERT_COLOR" },
        { text: "ODMサーモオルソEPSGコード交換", value: "732_ODM_EPSG_CONVERT_THERMAL" },
        { text: "ODM可視オルソ画像サイズ縮小化", value: "741_ODM_RES50_COLOR" },
        { text: "ODMサーモオルソ画像サイズ縮小化", value: "742_ODM_RES50_THERMAL" },
        { text: "ODM可視サムネル作成", value: "761_ODM_THUMBNAIL_COLOR" },
        { text: "ODMサーモサムネル作成", value: "762_ODM_THUMBNAIL_THERMAL" },
        { text: "ODM可視補正座標抽出", value: "781_ODM_CCALC_COLOR" },
        { text: "ODMサーモ補正座標抽出", value: "782_ODM_CCALC_THERMAL" },

        { text: "ODMLightning可視再構築", value: "801_ODM_LIGHTNING_RERUN_COLOR" },
        { text: "ODMLightningサーモ再構築", value: "802_ODM_LIGHTNING_RERUN_THERMAL" },

        { text: "ODM可視再構築", value: "901_ODM_RERUN_COLOR" },
        { text: "ODMサーモ再構築", value: "902_ODM_RERUN_THERMAL" },
      ],
      statusName: [
        { text: "API結果：処理開始", value: "NEW"},
        { text: "API結果：処理予約中", value: "QUEUED"},
        { text: "API結果：処理中", value: "PROCESSING"},
        { text: "API結果：失敗", value: "FAILED"},
        { text: "API呼び出し失敗", value: "API_ERROR"},
        { text: "完了", value: "COMPLETE"},
        { text: "エクスポートAPI呼び出しの失敗", value: "EXPORT_ERROR"},
        { text: "エクスポートAPI呼び出しが一部失敗", value: "EXPORT_WARNING"},
        { text: "API結果：送信中", value: "INGESTION"},
        { text: "API結果：解析中", value: "ANALYSIS_INPROGRESS"},
        { text: "API結果：解析完了", value: "ANALYSIS_COMPLETED"},
        { text: "API結果：解析失敗", value: "ANALYSIS_FAILED"},
        { text: "アップロードファイルへの追加失敗", value: "ADDFILE_WARNING"},
        { text: "異常の個別画像反映失敗", value: "IMPORT_ANNOTATION_ERROR"},
        { text: "API進捗がないため処理中断", value: "NO_PROGRESS"},
        { text: "異常のマップ反映失敗", value: "READ_CSV_ERROR"},
        { text: "異常種類が未定義", value: "UNDEFINE_ANOMALY_TYPE_WARNING"},
        { text: "不明なエラー", value: "UNKNOWN_ERROR"},
        { text: "処理開始", value: "PROCESS_START"},
        { text: "一部失敗", value: "PROCESS_INCOMPLETE"},
        { text: "失敗", value: "PROCESS_FAILED"},
      ],
      offsetTop: 0,
      s3Axios: new S3Axios(this.axios).s3Axios
    };
  },
  methods: {
    setInputForder() {
      this.inputEditFolder = JSON.parse(JSON.stringify(this.folder));
    },
    getFolder() {
      this.axios
          .get("/api/folder/" + this.$route.params.folderId)
          .then((response) => {
            this.folder = response.data.folder;
            this.breadcrumbs[2].text = this.folder.property.shooting_date;
            this.setInputForder();
            this.getPlant(this.folder.plant_id);
            this.folder_detail_logs = response.data.folder_detail_logs;
          });
    },
    getImagesStructure() {
      this.axios
          .get("/api/folder/structure/" + this.$route.params.folderId)
          .then((response) => {
            const list = response.data;
            this.imagesStructure.colorFiles = list.filter((x) =>
                x.includes("/images/color/")
            );
            this.imagesStructure.thermalFiles = list.filter((x) =>
                x.includes("/images/thermal/")
            );
          });
    },
    getFiles() {
      this.files = [];
      const filter = {
        folder_id: this.$route.params.folderId,
      };
      this.axios.post("/api/files", filter).then((response) => {
        this.files = response.data;
      });
    },
    getPlant(plantId) {
      this.axios
          .get('/api/main-plant/' + plantId)
          .then((response)=>{
            this.plant = response.data;
            this.breadcrumbs[1].text = this.plant.plant_name;
            this.breadcrumbs[1].to = "/plant/" + plantId + "/folder";
          });
    },
    editFolder() {
      if (this.$refs.editFolderForm.validate()) {
        this.axios
            .put(
                "/api/folder/" + this.$route.params.folderId,
                this.inputEditFolder
            )
            .then((response) => {
              this.folder = response.data;
              this.breadcrumbs[2].text = this.folder.property.shooting_date;
              this.closeEditFolderDialog();
              store.showSuccessDialog("データ情報編集が完了しました。");
            })
            .catch(() => {
              store.showErrorDialog("エラーが発生しました。再度試してください。");
            });
      }
    },
    closeEditFolderDialog() {
      this.editFolderDialog = false;
      this.$refs.editFolderForm.resetValidation();
      this.setInputForder();
    },
    closeImagesUploadDialog() {
      this.imagesUploadDialog = false;
      this.inputImagesUpload.images = [];
    },
    closeFileUploadDialog() {
      this.fileUploadDialog = false;
      this.$refs.fileUploadForm.reset();
    },
    onUploadImages() {
      this.$refs.imagesUploader.click();
    },
    addImages(e) {
      if (!e.target.files || e.target.files.length === 0) return;
      for (const file of e.target.files) {
        // 画像が重複じゃないと画像一覧に追加する。
        if (
            !this.inputImagesUpload.images.some(
                (x) => x.name === file.name && x.size === file.size
            )
        ) {
          this.inputImagesUpload.images.push(file);
        }
      }
    },
    uploadImages() {
      if (
          !this.inputImagesUpload.images ||
          this.inputImagesUpload.images.length === 0
      ) {
        store.showErrorDialog("「画像追加」をクリックし、アップロードしたい画像を追加してください。");
        return;
      }
      this.snackbar = false;
      this.uploadedFilesNum = 0;
      this.uploadFilesNum = this.inputImagesUpload.images.length;
      this.loading = "uploading";
      this.uploadingDialog = true;
      const uploadStatus = new Array(this.inputImagesUpload.images.length); //Value: color, thermal, error
      for (let i = 0; i < this.inputImagesUpload.images.length; i++) {
        const data = new FormData();
        data.append("file", this.inputImagesUpload.images[i]);
        this.axios
            .post(
                "/api/folder/images/upload/" + this.$route.params.folderId,
                data
            )
            .then((response) => {
              uploadStatus[i] = response.data;
              // const coordinate = this.getCoordinate(this.inputImagesUpload.images[i]);
              // uploadStatus[i].push(coordinate);
            })
            .catch(() => {
              uploadStatus[i] = "error";
            })
            .then(() => {
              this.uploadedFilesNum = uploadStatus.filter(
                  (x) => x != undefined
              ).length;
              if (!uploadStatus.includes(undefined)) {
                if (!uploadStatus.includes("error")) {
                  //全ての画像がアップロード済なら完了APIを呼び出す。
                  this.loading = "completing";
                  this.updateFolderProperty(this.inputImagesUpload.images[0]);
                  // const completeTypes = this.getCompletedTypes(uploadStatus);
                  // this.completeUploadImages(completeTypes);

                  // console.log(uploadStatus);
                  const data = uploadStatus;
                  this.completeUploadImages(data);
                } else {
                  //アップロードできない画像があればアップロードできない画像一覧を表示する。
                  const errorIndexs = uploadStatus
                      .map((_, i) => i)
                      .filter((j) => uploadStatus[j] === "error");
                  this.errorFileNames = errorIndexs.map(
                      (x, i) => i + 1 + ". " + this.inputImagesUpload.images[x].name
                  );
                  const errorMsg =
                      "アップロードできない下記のファイルを再度アップロードしてください。\n" +
                      this.errorFileNames.join("\n");
                  store.showErrorDialog(errorMsg);
                  this.snackbar = true;
                  this.loading = "done";
                  this.uploadingDialog = false;
                  this.getImagesStructure();
                }
                this.closeImagesUploadDialog();
              }
            });
      }
    },
    updateFolderProperty(file) {
      const data = new FormData();
      data.append("file", file);
      this.axios
          .post("/api/folder/property/" + this.$route.params.folderId, data)
          .then(() => {
            this.getFolder();
          });
    },
    getCompletedTypes(uploadStatus) {
      const result = [];
      if (uploadStatus.includes("color")) result.push("color")
      if (uploadStatus.includes("thermal")) result.push("thermal")
      return result
    },
    completeUploadImages(data) {
      const completedTypes = [];
      const coordinate = {
        'color': [],
        'thermal': [],
      };
      data.forEach((element,key) => {
        // completeTypes[key] = element["color_type"];
        // coordinate[key] = element["coordinate"];
        completedTypes[key] = element["color_type"];
        coordinate[element["color_type"]].push(element["coordinate"]);
      });
      const body = {
        completedTypes: this.getCompletedTypes(completedTypes),
        coordinate: coordinate,
      }
      this.axios
          .post("/api/folder/images/complete/" + this.$route.params.folderId, body)
          .then(() => {
            store.showSuccessDialog("アップロードが完了しました。");
          })
          .catch(() => {
            store.showErrorDialog("アップロードできましたが、アップロードの後処理にてエラーが発生しました。管理者に連絡してください。");
          })
          .then(() => {
            this.loading = "done";
            this.uploadingDialog = false;
            this.getImagesStructure();
          });
    },
    uploadFile() {
      if (this.$refs.fileUploadForm.validate()) {
        if (!this.inputFileUpload.file) return;
        this.uploadRate = 0;
        this.uploadedFilesNum = 0;
        this.uploadFilesNum = 1;
        this.loading = "uploading";
        this.uploadingDialog = true;
        const data = new FormData();
        data.append("folder_id", this.$route.params.folderId);
        data.append("app", this.inputFileUpload.app);
        data.append("name", this.inputFileUpload.file.name);
        data.append("file_size", this.inputFileUpload.file.size);
        data.append("file_type", this.inputFileUpload.fileType);
        data.append("color_type", this.inputFileUpload.colorType);
        this.axios.post("/api/file/presigned-urls", data)
            .then(response => {
              
              const pData = response.data;
              const promises = [];
              let uploadedPartCount = 0;
              for (let i = 0; i < pData.partCount; i++) {
                const start = i * pData.partSize;
                const end = (i + 1) * pData.partSize;
                const blob = i + 1 < pData.partCount ? this.inputFileUpload.file.slice(start, end) : this.inputFileUpload.file.slice(start);
                promises.push(
                  this.s3Axios.put(pData.presignedUrls[i], blob)
                    .then(() => {
                      uploadedPartCount++;
                      this.uploadRate = 100 * uploadedPartCount / pData.partCount;
                    })
                );
              }
              Promise.all(promises)
                .then(() => {
                  this.loading = "completing";
                  data.append("path", pData.path);
                  data.append("uploadId", pData.uploadId);
                  this.axios.post("/api/file/complete-multipart-upload", data)
                    .then(() => {
                      store.showSuccessDialog("アップロードが完了しました。");
                    })
                    .catch(() => {
                      store.showErrorDialog("エラーが発生しました。再度アップロードしてください。");
                    })
                    .finally(() => {
                      this.closeFileUploadDialog();
                      this.loading = "done";
                      this.uploadingDialog = false;
                      this.getFiles();
                    })
                })
                .catch(() => {
                  store.showErrorDialog("エラーが発生しました。再度アップロードしてください。");
                  this.closeFileUploadDialog();
                  this.loading = "done";
                  this.uploadingDialog = false;
                  this.getFiles();
                })
            })
            .catch(() => {
              store.showErrorDialog("エラーが発生しました。再度アップロードしてください。");
              this.closeFileUploadDialog();
              this.loading = "done";
              this.uploadingDialog = false;
              this.getFiles();
            })
      }
    },
    viewFile(file) {
      this.axios
          .post("/api/link", { path: file.path })
          .then((response) => {
            const fileLink = document.createElement("a");
            fileLink.href = response.data;
            fileLink.setAttribute("target", "_blank");
            document.body.appendChild(fileLink);
            fileLink.click();
            document.body.removeChild(fileLink);
          })
          .catch(() => {
            store.showErrorDialog("エラーが発生しました。再度試してください。");
          });
    },
    download(path, filename) {
      this.axios
          .post("/api/link", { path: path })
          .then((response) => {
            if (
                filename.toLowerCase().includes(".jpg") ||
                filename.toLowerCase().includes(".jpeg") ||
                filename.toLowerCase().includes(".png") ||
                filename.toLowerCase().includes(".tif") ||
                filename.toLowerCase().includes(".tiff")
            ) {
              saveAs(response.data, filename);
            } else {
              window.location.href = response.data;
            }
          })
          .catch(() => {
            store.showErrorDialog("エラーが発生しました。再度試してください。");
          });
    },
    downloadZip(colorType) {
      window.location.href = `/api/folder/images/download/${this.$route.params.folderId}/${colorType}?token=${store.state.token}`;
    },
    confirmDeleteFile(file) {
      const confirmDialog = {
        title: '削除確認',
        content: "「" + file.name + "」を削除します。よろしいですか。",
        onAgree: () => this.deleteFile(file),
        onDisagree: null,
      }
      store.showConfirmDialog(confirmDialog);
    },
    deleteFile(file) {
      this.axios
          .delete("/api/file/" + file.id)
          .then(() => {
            this.getFiles();
            store.showSuccessDialog("「" + file.name + "」削除が完了しました。");
          })
          .catch(() => {
            store.showErrorDialog("エラーが発生しました。再度試してください。");
          });
    },
    confirmDeleteImages(colorType) {
      const confirmDialog = {
        title: '削除確認',
        content: `${this.getColorTypeString(colorType)}画像を削除します。よろしいですか。`,
        onAgree: () => this.deleteImages(colorType),
        onDisagree: null,
      };
      store.showConfirmDialog(confirmDialog);
    },
    deleteImages(colorType) {
      this.axios
          .post("/api/folder/images/delete/" + this.$route.params.folderId, {
            colorType: colorType,
          })
          .then(() => {
            this.getImagesStructure();
            store.showSuccessDialog(`${this.getColorTypeString(colorType)}画像削除が完了しました。`);
          })
          .catch(() => {
            store.showErrorDialog("エラーが発生しました。再度試してください。");
          });
    },
    getColorTypeString(colorType) {
      const colorTypeString = {
        color: "可視",
        thermal: "サーモ",
      };
      return colorTypeString[colorType];
    },
    getProcessName(value) {
      return this.processTypes.find(x => x.value === value).text;
    },
    getStatusName(value) {
      return this.statusName.find( x=> x.value === value).text;
    },
    onScroll (e) {
      this.offsetTop = e.target.scrollTop
    },
    // convertDMSToDD(degrees, minutes, seconds, direction) {
    //   var dd = degrees + (minutes/60) + (seconds/3600);

    //   if (direction == "S" || direction == "W") {
    //       dd = dd * -1;
    //   }

    //   return dd;
    // },
    // getCoordinate(myData) {
    //   var coordinate = [];
    //   var latDegree = myData.exifdata.GPSLatitude[0].numerator;
    //   var latMinute = myData.exifdata.GPSLatitude[1].numerator;
    //   var latSecond = myData.exifdata.GPSLatitude[2].numerator;
    //   var latDirection = myData.exifdata.GPSLatitudeRef;
    //   var latFinal = this.convertDMSToDD(latDegree, latMinute, latSecond, latDirection);
    //   console.log(latFinal);
    //   coordinate["latitude"] = latFinal;
    //   // Calculate longitude decimal
    //   var lonDegree = myData.exifdata.GPSLongitude[0].numerator;
    //   var lonMinute = myData.exifdata.GPSLongitude[1].numerator;
    //   var lonSecond = myData.exifdata.GPSLongitude[2].numerator;
    //   var lonDirection = myData.exifdata.GPSLongitudeRef;
    //   var lonFinal = this.convertDMSToDD(lonDegree, lonMinute, lonSecond, lonDirection);
    //   console.log(lonFinal);
    //   coordinate["longitude"] = lonFinal;
    //   return coordinate;
    // }
  },
  created() {
    this.getFolder();
    this.getImagesStructure();
    this.getFiles();
  },
};
</script>

<style lang="scss">
// tr.dronedeploy {
//   background: #d3f8f8;
// }
// tr.pix4d {
//   background: #fff1ce;
// }
// tr.terra {
//   background: #d2e4c6;
// }
.theme--light.v-data-table.tb-readonly
> .v-data-table__wrapper
> table
> thead
> tr:last-child
> th {
  border-bottom: none;
}
.theme--light.v-data-table.tb-readonly
> .v-data-table__wrapper
> table
> tbody
> tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: initial;
}
.overlay-content {
  background: #fff;
  color: #333;
  border-radius: 4px;
  padding: 16px;
}
.div-images-upload {
  border-bottom: 1px solid #ccc;
}
</style>
